import { render } from "./tooltipComponent.vue?vue&type=template&id=2ace9c17&scoped=true"
import script from "./tooltipComponent.vue?vue&type=script&lang=js"
export * from "./tooltipComponent.vue?vue&type=script&lang=js"

import "./tooltipComponent.vue?vue&type=style&index=0&id=2ace9c17&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ace9c17"]])

export default __exports__